export const FINANCE_REPORTS_CHILDREN_REVENUE_PER_AGE = 'FINANCE_REPORTS_CHILDREN_REVENUE_PER_AGE'
export const FINANCE_REPORTS_CHILDREN_REVENUE_PER_AGE_SUCCESS = 'FINANCE_REPORTS_CHILDREN_REVENUE_PER_AGE_SUCCESS'
export const FINANCE_REPORTS_CHILDREN_REVENUE_PER_AGE_FAILED = 'FINANCE_REPORTS_CHILDREN_REVENUE_PER_AGE_FAILED'

export const CLEAR_FINANCE_REPORTS_CHILDREN_REVENUE_PER_AGE = 'CLEAR_FINANCE_REPORTS_CHILDREN_REVENUE_PER_AGE'
